class MediaGallery {
  constructor() {
    this.wrapper = document.querySelector("media-gallery");
    if (!this.wrapper) return;
    if (window._lastColor === undefined) window._lastColor = null;
    this.mobileSwiper = null;
    this.mediaData = null;
    this.driftInstances = new Map();
    this.init();
  }

  init() {
    this.initMobileSwiper();
    this.enableMobilePinchZoom();
    this.initDriftZoom();
    this.bindEvents();
  }

  /* ---------------- MOBILE SWIPER ---------------- */
  initMobileSwiper() {
    const el = this.wrapper.querySelector(".media-gallery__mobile");
    if (!el) return;

    if (this.mobileSwiper) this.mobileSwiper.destroy(true, true);

    this.mobileSwiper = new Swiper(el, {
      slidesPerView: 1,
      speed: 350,
      pagination: {
        el: ".media-gallery__pagination",
        type: "progressbar",
      },
    });
  }

  /* ---------------- PINCH ZOOM ---------------- */
  enableMobilePinchZoom() {
    const imgs = this.wrapper.querySelectorAll(".media-gallery__img--mobile");

    imgs.forEach(img => {
      let startDistance = 0;
      let currentScale = 1;

      img.addEventListener("touchstart", ev => {
        if (ev.touches.length === 2) {
          const dx = ev.touches[0].clientX - ev.touches[1].clientX;
          const dy = ev.touches[0].clientY - ev.touches[1].clientY;
          startDistance = Math.sqrt(dx * dx + dy * dy);
          this.mobileSwiper.allowTouchMove = false;
        }
      }, { passive: true });

      img.addEventListener("touchmove", ev => {
        if (ev.touches.length === 2) {
          ev.preventDefault();
          const dx = ev.touches[0].clientX - ev.touches[1].clientX;
          const dy = ev.touches[0].clientY - ev.touches[1].clientY;
          const newDist = Math.sqrt(dx * dx + dy * dy);
          let scale = Math.min(Math.max(newDist / startDistance, 1), 3);
          img.style.transform = `scale(${scale})`;
          currentScale = scale;
        }
      }, { passive: false });

      img.addEventListener("touchend", () => {
        if (currentScale < 1.1) img.style.transform = "scale(1)";
        this.mobileSwiper.allowTouchMove = true;
      });
    });
  }

  /* ---------------- DRIFT ZOOM ---------------- */
  initDriftZoom() {
    if (window.innerWidth < 768) return;

    const images = this.wrapper.querySelectorAll(".media-gallery__img--zoom");

    this.driftInstances.forEach(inst => inst.destroy());
    this.driftInstances.clear();

    images.forEach(img => {
      img.style.cursor = "zoom-in";

      img.onclick = event => {
        if (this.driftInstances.has(img)) {
          this.driftInstances.get(img).destroy();
          this.driftInstances.delete(img);
          img.style.cursor = "zoom-in";
          return;
        }

        this.driftInstances.forEach((inst, el) => {
          inst.destroy();
          el.style.cursor = "zoom-in";
        });
        this.driftInstances.clear();

        const drift = new Drift(img, {
          inlinePane: true,
          containInline: true,
          zoomFactor: 2.4,
          sourceAttribute: "data-zoom",
          inlineContainer: img.closest(".media-gallery__zoom-wrap"),
          hoverBoundingBox: false,
          handleTouch: false
        });

        this.driftInstances.set(img, drift);
        drift.trigger._show();

        const rect = img.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width;
        const y = (event.clientY - rect.top) / rect.height;

        drift.zoomPane.setPosition(x, y, rect);
        img.style.cursor = "zoom-out";
      };
    });
  }

  /* ---------------- VARIANT LISTENER ---------------- */
  bindEvents() {
  if (window._lastColor === undefined) window._lastColor = null;

  document.addEventListener("variant:change", e => {
    const color = e.detail?.color;
    if (!color) return;

    // Stop reload if color did not change
    if (window._lastColor === color) return;

    window._lastColor = color;
    this.reloadSection(color);
  });
}


  /* ---------------- RELOAD SECTION ---------------- */
  reloadSection(color) {
    if (!this.mediaData) {
      this.mediaData = JSON.parse(
        document.querySelector("#media-data-json").textContent.trim()
      );
    }

    const mediaArr = this.mediaData[color];
    if (!mediaArr) return;

    /* ========== MOBILE ========== */
    const mobile = this.wrapper.querySelector(".media-gallery__mobile .swiper-wrapper");
    mobile.innerHTML = "";

    // 1. NORMAL IMAGES
    mediaArr.forEach(m => {
      mobile.innerHTML += `
        <div class="swiper-slide">
          <img class="media-gallery__img media-gallery__img--mobile"
               src="${m.src}" alt="${m.alt}">
        </div>`;
    });

    // 2. DIAGRAM AT POSITION #3
    if (window.diagramImage) {
      const diag = `
        <div class="swiper-slide" data-color="diagram">
          <img class="media-gallery__img media-gallery__img--mobile"
               src="${window.diagramImage.src}" alt="${window.diagramImage.alt}">
        </div>
      `;

      if (mobile.children.length >= 2) {
        mobile.children[1].insertAdjacentHTML("afterend", diag);
      } else {
        mobile.insertAdjacentHTML("beforeend", diag);
      }
    }

    // 3. VIDEO ALWAYS LAST
    if (window.videoHTML) {
      mobile.insertAdjacentHTML(
        "beforeend",
        `<div class="swiper-slide" data-color="all_colors">${window.videoHTML}</div>`
      );
    }

    /* ========== DESKTOP ========== */
    const desktop = this.wrapper.querySelector(".media-gallery__desktop");
    desktop.innerHTML = "";

    // 1. NORMAL IMAGES
    mediaArr.forEach(m => {
      desktop.innerHTML += `
        <div class="media-gallery__item">
          <div class="media-gallery__zoom-wrap">
            <img class="media-gallery__img media-gallery__img--desktop media-gallery__img--zoom"
                 src="${m.src}" data-zoom="${m.zoom}" alt="${m.alt}">
          </div>
        </div>`;
    });

    // 2. DIAGRAM AT POSITION #3
    if (window.diagramImage) {
      const diagHTML = `
        <div class="media-gallery__item">
          <div class="media-gallery__zoom-wrap">
            <img class="media-gallery__img media-gallery__img--desktop media-gallery__img--zoom"
                 src="${window.diagramImage.src}" data-zoom="${window.diagramImage.zoom}"
                 alt="${window.diagramImage.alt}">
          </div>
        </div>
      `;

      if (desktop.children.length >= 2) {
        desktop.children[1].insertAdjacentHTML("afterend", diagHTML);
      } else {
        desktop.insertAdjacentHTML("beforeend", diagHTML);
      }
    }

    // 3. VIDEO LAST
    if (window.videoHTML) {
      desktop.insertAdjacentHTML(
        "beforeend",
        `<div class="media-gallery__item">${window.videoHTML}</div>`
      );
    }

    /* Re-init Swiper + Zoom */
    this.initMobileSwiper();
    this.enableMobilePinchZoom();
    this.initDriftZoom();
  }
}

window.addEventListener("load", () => new MediaGallery());
